/**
 * Module dependencies.
 */

import { FormList } from 'app/components/organisms/crud/form-types';
import { requiredRule } from 'app/core/utils/field-rules';
import { TFunction } from 'react-i18next';
import { makePhoneUserLookupField } from './phone-user-lookup-field';

/**
 * Left.
 */

const left = (translate: TFunction, type: 'add' | 'edit'): FormList => [
  {
    type: 'render',
    name: 'phoneNumber',
    renderComponent: makePhoneUserLookupField(type, translate)
  },
  {
    type: 'selectField',
    name: 'status',
    label: translate('common.labels.status'),
    rules: requiredRule(translate),
    options: [
      {
        value: 'created',
        label: String(translate('common.labels.statusLabels.created'))
      },
      {
        value: 'pending',
        label: String(translate('common.labels.statusLabels.pending'))
      },
      {
        value: 'approved',
        label: String(translate('common.labels.statusLabels.approved'))
      },
      {
        value: 'userRevoked',
        label: String(translate('common.labels.statusLabels.userRevoked'))
      },
      {
        value: 'pharmacyRevoked',
        label: String(translate('common.labels.statusLabels.pharmacyRevoked'))
      }
    ]
  },
  {
    type: 'inputField',
    name: 'externalId',
    label: translate('common.labels.externalId'),
    rules: undefined
  }
];

/**
 * Right.
 */

const right = (translate: TFunction): FormList => [
  {
    type: 'inputField',
    name: 'createdAt',
    disabled: true,
    label: translate('common.labels.createdAt'),
    rules: undefined
  },
  {
    type: 'inputField',
    name: 'updatedAt',
    disabled: true,
    label: translate('common.labels.updatedAt'),
    rules: undefined
  }
];

/**
 * Export `formFields`.
 */

export const formFields = (translate: TFunction, type: 'add' | 'edit'): FormList => [
  {
    type: 'columns',
    gutter: 40,
    name: 'mainWire',
    columns: [
      {
        column: 18,
        children: left(translate, type)
      },
      {
        column: 6,
        children: right(translate)
      }
    ]
  }
];
